// This file was generated by "make codegen/iam". DO NOT EDIT.
// source: <server_repo_dir>/policy/cnquery_cnspec_actions.go

import { type ReactNode } from "react";
import { type Scope } from "~/hooks/useScope";
import { useCanSetBundle } from "./hook";

export type CanSetBundleProps = {
  children?: ReactNode;
  fallback?: ReactNode;
  scope?: Scope;
};

export function CanSetBundle({ children, fallback, scope }: CanSetBundleProps) {
  const canDoAction = useCanSetBundle(scope);
  return <>{canDoAction ? children : fallback}</>;
}
